module.exports = __webpack_public_path__ + "static/media/welcoming-instance.732560f0.png";